import React from 'react';
import ReactDOM from 'react-dom';
import MstAnalytics from 'mst-analytics';
import Download from '~/components/pages/download';
import '~/assets/styles/common.scss';
import { queryParse } from '~/utils/query';

MstAnalytics.init({
  appKey: 'wg22vlfgaqtfqywspolipkqt',
  pageConfig: {},
});

let urlParams = {}; // 地址栏的参数，需要上报给qt，大数据子游说BI里要用chanel参数
try {
  const curHash = window.location.search || '';
  urlParams = queryParse(curHash) || {};
} catch (error) {
  console.log('获取地址栏参数出错');
}

MstAnalytics.separatelyReport('ewt_h5_base_public_download_call_app_view', {
  ...urlParams,
});

ReactDOM.render(
  <Download />,
  document.getElementById('mst-app'),
);



// WEBPACK FOOTER //
// ./src/entries/download/download.jsx